<div class="card mb-3">
  <div class="card-body">
    <div class="row align-items-end">
      <div class="col-md-2 mb-2">
        <label>Begin date</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="begDate">
      </div>

      <div class="col-md-2 mb-2">
        <label>End date</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="endDate">
      </div>

      <div class="col-md-2 mb-2">
        <label>Status</label>
        <select class="form-control form-control-sm" [(ngModel)]="statusId">
          <option [ngValue]="0">All Statuses</option>
          <option *ngFor="let s of statusObj" [ngValue]="s.id">{{ s.name }}</option>
        </select>
      </div>

      <div class="col-md-3 mb-2">
        <label>Search</label>
        <input type="text"
               class="form-control form-control-sm"
               [(ngModel)]="searchText"
               (input)="onSearchChange()"
               placeholder="Search...">
      </div>





      <div class="col-md-1 mb-2">
        <button class="btn btn-primary btn-sm btn-block" (click)="loadReport()">
          <span class="fas fa-search"></span>
        </button>
      </div>

      <div class="col-md-2 mb-2">
        <button class="btn btn-success btn-sm btn-block" (click)="exportToExcel()">
          <span class="fas fa-file-excel mr-1"></span> Export
        </button>
      </div>

    </div>
  </div>
</div>

<div class="card mb-3">
  <div class="card-body d-flex justify-content-between align-items-center flex-wrap">
    <h6 class="mb-0">Showing {{ filteredData.length }} records</h6>
    <div class="mt-2 mt-md-0">
      <span class="badge badge-soft-info mr-2">Total Qty: {{ totalQty }}</span>
      <span class="badge badge-soft-success">Total Price: {{ totalPrice | number:'1.2-2' }} ₼</span>
    </div>
  </div>
</div>

<div class="card">
  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table table-sm mb-0">
        <thead class="slb-header fs--1">
          <tr>
            <th>#</th>
            <th>Item Code</th>
            <th>Item Name</th>
            <th>User</th>
            <th class="align-middle">Seg. Level 1</th>
            <th class="align-middle">Seg. Level 2</th>
            <th class="align-middle">Seg. Level 3</th>
            <th class="text-center">Qty</th>
            <th class="text-center">Price</th>
          </tr>
        </thead>

        <tbody *ngIf="!isLoading && pagedData.length > 0">
          <tr *ngFor="let item of pagedData; let i = index">
            <td>{{ ((currentPage - 1) * pageSize) + i + 1 }}</td>
            <td>{{ item.itemCode }}</td>
            <td>{{ item.itemName }}</td>
            <td>{{ item.userName }}</td>
            <td>{{ item.segment1 }}</td>
            <td>{{ item.segment2 }}</td>
            <td>{{ item.segment3 }}</td>
            <td class="text-center">{{ item.totalQty }}</td>
            <td class="text-center">{{ item.totalPrice | number:'1.2-2' }} ₼</td>
          </tr>
        </tbody>

        <tbody *ngIf="isLoading">
          <tr>
            <td colspan="9" class="text-center py-4">Loading...</td>
          </tr>
        </tbody>

        <tbody *ngIf="!isLoading && pagedData.length === 0">
          <tr>
            <td colspan="9" class="text-center py-4">No data found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-footer">
    <ul class="pagination pagination-sm mb-0 justify-content-end flex-wrap">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="javascript:void(0)" (click)="changePage(currentPage - 1)">Prev</a>
      </li>

      <li class="page-item" *ngFor="let p of pages" [class.active]="p === currentPage">
        <a class="page-link" href="javascript:void(0)" (click)="changePage(p)">{{ p }}</a>
      </li>

      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="javascript:void(0)" (click)="changePage(currentPage + 1)">Next</a>
      </li>
    </ul>
  </div>
</div>
